"use client";

import EditableText from "@/app/(components)/generics/EditableText/EditableText";
import IconPlus from "@/app/(components)/generics/Icons/IconPlus";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { Limits } from "@/app/vars/Limits";
import styles from "./ProspectStrategy.module.css";

type Props = {
  adding: boolean;
  canAdd: boolean;
  lang: string;
  onStart: () => void;
  onAdd: (value: string) => void;
  onCancel: () => void;
};

export default function ProspectStrategyAddValue(props: Props) {
  const T = useT();
  const { adding, canAdd, onStart, onAdd, onCancel } = props;

  if (adding) {
    return (
      <span className={styles.chipEdit}>
        <EditableText
          value=""
          maxLength={Limits.MAX_PROSPECT_STRATEGY_VALUE}
          placeholder={T(TKey.NEW_DOTS) as string}
          onSave={onAdd}
          onCancel={onCancel}
          alwaysShowEdit={true}
          startEditingOnMount={true}
          className={styles.chipEditText}
        />
      </span>
    );
  }

  if (!canAdd) {
    return null;
  }

  return (
    <button type="button" className={styles.addBtn} onClick={onStart}>
      <IconPlus />
      <span>{T(TKey.ADD_ITEM)}</span>
    </button>
  );
}
